var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c("div", { staticClass: "drawer" }, [
        _c(
          "a",
          {
            on: {
              click: function($event) {
                _vm.open = false
              }
            }
          },
          [_vm._v("CLOSE")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "items" },
          _vm._l(_vm.data.items, function(item) {
            return _c("item", _vm._b({ key: item.id }, "item", item, false))
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "total" }, [
          _vm._v("Total: " + _vm._s(_vm.data.total_price / 100))
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }